import { useEffect, useState } from "react";

const VERSION_URL = "/assets/version.json";
const DEFAULT_STORAGE_KEY = "appVersion";

type VersionResponse = {
  version: string;
};

export function useVersionCheck(
  storageKey = DEFAULT_STORAGE_KEY
): string | null {
  const [remoteVersion, setRemoteVersion] = useState<string | null>(null);

  useEffect(() => {
    let isActive = true;

    const checkVersion = async () => {
      try {
        const response = await fetch(VERSION_URL, { cache: "no-cache" });

        if (!response.ok) {
          throw new Error(`Failed to load version.json: ${response.status}`);
        }

        const { version } = (await response.json()) as VersionResponse;

        if (!isActive) return;

        setRemoteVersion(version);

        const localVersion = localStorage.getItem(storageKey);

        if (!localVersion) {
          localStorage.setItem(storageKey, version);
          return;
        }

        if (localVersion !== version) {
          localStorage.setItem(storageKey, version);
          window.location.reload();
        }
      } catch (error) {
        console.error("Version check error:", error);
      }
    };

    checkVersion();

    return () => {
      isActive = false;
    };
  }, [storageKey]);

  return remoteVersion;
}
